import { Outlet } from 'react-router';
import PageLayout from '@/components/page-layout';
import { Container, Sidebar } from './components';
import { sidebarItems } from './config';

export const Sessions = () => {
	return (
		<PageLayout>
			<Container>
				<Sidebar title="Sessions" items={sidebarItems} />
				<Outlet />
			</Container>
		</PageLayout>
	);
};
